import { Component, Input, OnInit } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PipesModule } from 'src/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { Boulder } from 'src/model/boulder';
import { BoulderListEntryComponent } from '../boulder-list-entry/boulder-list-entry.component';
import { BoulderDetailsPage } from 'src/pages/boulder-details/boulder-details.page';

@Component({
    standalone: true,
    imports: [IonicModule, FormsModule, CommonModule, PipesModule, TranslateModule, BoulderListEntryComponent],
    selector: 'boulders',
    template: `
    <ion-header>
        <ion-toolbar class="emoji-modal-toolbar">
            <ion-title *ngIf="_title">{{_title}}</ion-title>
            <ion-buttons slot="end">
                <ion-button color="primary" (click)="dismiss()">
                <ion-icon name="close-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
     <ion-list>
        <app-boulder-list-entry *ngFor="let boulder of _boulders" (click)="showBoulder(boulder.boulderId)" [boulder-list-entry]="boulder"></app-boulder-list-entry>
     </ion-list>
    </ion-content>
  `,
    styleUrls: [],
})
export class BouldersComponent {

    @Input('boulders')
    set boulders(boulders: Boulder[]) {
        this._boulders = boulders;
    }

    @Input('title')
    set title(title: string) {
        this._title = title;
    }

    _boulders: Boulder[];
    _title: string;

    constructor(private modalController: ModalController) {
    }

    public dismiss() {
        this.modalController.dismiss();
    }

    async showBoulder(boulderId: string) {
        const modal = await this.modalController.create({
            id: 'boulder-details-modal',
            component: BoulderDetailsPage,
            componentProps: {
                boulderId: boulderId
            }
        });
        return await modal.present();
    }

}
